import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/components/PageLayout/index.ts";
export const data = {
  title: "Contact Us",
  subtitle: "Want to get in touch? I'd love to hear from you."
};
export const _frontmatter = {};
const layoutProps = {
  data,
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h2>{`Get in Touch`}</h2>
    <p>{`Interested in collaborating with me? Shoot me an email. `}</p>
    <p><strong parentName="p">{`Email:`}</strong>{` `}<a parentName="p" {...{
        "href": "mailto:dev.cheuk.lee@gmail.com"
      }}>{`dev.cheuk.lee@gmail.com`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      